/**
 * GET INDUSTRIES
 */

export const GET_INDUSTRIES_REQUEST = "GET_INDUSTRIES_REQUEST";
export const GET_INDUSTRIES_SUCCESS = "GET_INDUSTRIES_SUCCESS";
